import React from "react";

class Popup extends React.Component {
    componentDidMount() {
        const {adId, popUpType} = this.props
        const scriptEl = document.createElement("script");
        scriptEl.async = true;
        scriptEl.src = 'https://onlydaily.net/pops.js'
        scriptEl.addEventListener('load', function () {
            ytrgt.popunder.init({
                href: `https://onlydaily.net/widget.html?block_id=${adId}`,
                mode: popUpType,
                refs: [],
                selector: "a",
                frequency: 1
            })
        });
        document.body.append(scriptEl);
    }

    render() {
        return null;
    }
}

export default Popup;
